import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";

class DynamicCheckboxControl extends React.Component {
  render() {
    let field = this.props.field;

    return (
      <FormControl component="fieldset" margin="none" fullWidth>
        <fieldset className="entity-fieldset">
          <Typography component="legend" color="primary">
            <legend>
              {field.IsMandatory ? "*" : ""}
              {field.FieldName}
            </legend>
          </Typography>
          <p dangerouslySetInnerHTML={{ __html: field.HelpText }}></p>
          <FormGroup
            onChange={this.props.eventHandle}
            style={{ marginLeft: 10 }}
          >
            {field.Options.map((option) => (
              <FormControlLabel   
                //checked={function that returns boolean type}  TODO: check if option is set in form state - form[field.FieldCode] values          
                name={field.FieldCode}                
                key={option}
                control={<Checkbox value={option} />}
                label={option}
              />
            ))}
          </FormGroup>
          <Typography variant="body2" color="error">
            {this.props.fieldError}
          </Typography>
        </fieldset>
      </FormControl>
    );
  }
}

export default DynamicCheckboxControl;
